export const setClickedImage = (image) => ({
    type: 'SET_CLICKED_IMAGE',
    payload: image,
});